import { CookieCheckIcon } from './CookieCheckIcon';

/**
 * author: Colton Wiscombe
 * id DB07C270-5421-41A3-BBFF-350874DE3534
 * name cookie-check
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-check.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitCheckIcon = CookieCheckIcon;
export default BiscuitCheckIcon